import React from 'react'
import Link from 'next/link'
import Image from 'next/image'

interface LogoProps {
  logoUrl?: string
  title?: string
}

export const Logo: React.FC<LogoProps> = ({ logoUrl, title }) => {
  const url = logoUrl || '/'
  const src = '/assets/logo-header.svg'

  return (
    <Link href={url} aria-label={url} className="inline-block">
      <Image
        src={src}
        alt={title || 'Portal Solar - A marca líder em energia solar.'}
        width={100}
        height={28}
      />
    </Link>
  )
}
